import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    data: null,
    status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
};

const ProfileSlice = createSlice({
    name: 'profile',
    initialState,
    reducers: {
        dataRequest: (state) => {
            state.status = 'loading';
        },
        dataSuccess: (state, action) => {
            state.status = 'succeeded';
            state.data = action.payload;
        },
        dataFailure: (state, action) => {
            state.status = 'failed';
            state.error = action.payload;
        },
    },
});

export const selectProfile = (state) => state.profile;
export const { dataRequest, dataSuccess, dataFailure } = ProfileSlice.actions;
export default ProfileSlice.reducer;
